import {
  getDatabaseContainerType,
  getSelectionsAnalyticsAttributes,
  useAnalytics,
} from '@databases/analytics';
import { type ContentSelectionMode } from '@databases/redux/cellSelections/selectors';
import { type ActionType } from '@databases/types/database';
import { type SelectionMode } from '@databases/types/database';
import { useCallback } from 'react';

import { ContentSelectionModeMap } from '../constants';

export type OnCloseActionBarTypes = {
  contentId: string;
  count: number;
  selectionMode: ContentSelectionMode;
};

export type OnSelectActionItemTypes = {
  type: ActionType;
  contentId: string;
  totalSelectedCount: number;
  selectionMode: SelectionMode;
};

export const useActionBarAnalytics = () => {
  const analyticsClient = useAnalytics();
  const databaseContainer = getDatabaseContainerType();

  const onCloseActionBar = useCallback(
    ({ contentId, count, selectionMode }: OnCloseActionBarTypes) => {
      analyticsClient.sendSelectedActionItemEvent({
        type: 'close',
        databaseContainer,
        contentId,
        selectedCount: count,
        selectionMode: ContentSelectionModeMap[selectionMode],
        ...getSelectionsAnalyticsAttributes(contentId),
      });
    },
    [analyticsClient, databaseContainer]
  );

  const onSelectActionItem = useCallback(
    ({ type, contentId, totalSelectedCount, selectionMode }: OnSelectActionItemTypes) => {
      analyticsClient.sendSelectedActionItemEvent({
        type,
        databaseContainer,
        contentId,
        selectedCount: totalSelectedCount,
        selectionMode,
        ...getSelectionsAnalyticsAttributes(contentId),
      });
    },
    [analyticsClient, databaseContainer]
  );

  return {
    onCloseActionBar,
    onSelectActionItem,
  };
};
